export * from './IconSchedule';
export { default as IconSchedule } from './IconSchedule';
